import React, { useRef } from 'react';
import {
  motion,
  useMotionValue,
  useTransform,
  useAnimationFrame,
  useReducedMotion
} from 'framer-motion';
import { homepageContent } from '../../data/products';
import './Marquee.css';

const wrap = (min, max, v) => {
  const range = max - min;
  return ((((v - min) % range) + range) % range) + min;
};

// Marquee that drifts on its own and reacts to scroll velocity:
// scrolling fast speeds it up, scrolling back up reverses it.
const Marquee = () => {
  const reduce = useReducedMotion();
  const paused = useRef(false);
  const phrases = homepageContent.marquee.items;

  const baseX = useMotionValue(0);
  const x = useTransform(baseX, (v) => `${wrap(-50, 0, v)}%`);

  useAnimationFrame((t, delta) => {
    if (reduce || paused.current) return;
    baseX.set(baseX.get() - (0.85 * delta / 1000));
  });

  const row = [...phrases, ...phrases];
  return (
    <div
      className="marquee"
      aria-hidden="true"
      onPointerEnter={() => { paused.current = true; }}
      onPointerLeave={() => { paused.current = false; }}
    >
      <motion.div className="marquee-track" style={{ x }}>
        {row.map((phrase, i) => (
          <span className="marquee-item" key={i}>
            {phrase}
            <i className="marquee-dot">•</i>
          </span>
        ))}
      </motion.div>
    </div>
  );
};
export default Marquee;
